// import React from "react";

// // ─── SVG icons ────────────────────────────────────────────────────────────────

// const CloseIcon = () => (
//   <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
//     <path d="M10 2L2 10M2 2l8 8" stroke="#6b7280" strokeWidth="1.5" strokeLinecap="round" />
//   </svg>
// );

// const EmailAccountIcon = ({ error }: { error?: boolean }) => (
//   <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//     <rect
//       x="0.5"
//       y="2.5"
//       width="15"
//       height="10.5"
//       rx="1.5"
//       stroke={error ? "#dc2626" : "#4f46e5"}
//       strokeWidth="1.2"
//       fill="none"
//     />
//     <path d="M0.5 5l7.5 4.5L15.5 5" stroke={error ? "#dc2626" : "#4f46e5"} strokeWidth="1.2" strokeLinecap="round" />
//   </svg>
// );

// const SmsAccountIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//     <rect x="0.5" y="1" width="15" height="11" rx="2" stroke="#059669" strokeWidth="1.2" fill="none" />
//     <path d="M3 13.5l2-2" stroke="#059669" strokeWidth="1.2" strokeLinecap="round" />
//     <path d="M4.5 6h7M4.5 8.5h5" stroke="#059669" strokeWidth="1.1" strokeLinecap="round" />
//   </svg>
// );

// const MoreDotsIcon = () => (
//   <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
//     <circle cx="6" cy="2.5" r=".9" fill="#9ca3af" />
//     <circle cx="6" cy="6" r=".9" fill="#9ca3af" />
//     <circle cx="6" cy="9.5" r=".9" fill="#9ca3af" />
//   </svg>
// );

// const PlusIcon = () => (
//   <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
//     <path d="M5 1v8M1 5h8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
//   </svg>
// );

// // ─── SectionLabel ─────────────────────────────────────────────────────────────

// const SectionLabel = ({ children }: { children: React.ReactNode }) => (
//   <p
//     style={{
//       fontSize: 10,
//       fontWeight: 700,
//       color: "#9ca3af",
//       textTransform: "uppercase",
//       letterSpacing: "0.9px",
//       marginBottom: 9,
//       marginTop: 8,
//     }}
//   >
//     {children}
//   </p>
// );

// // ─── StatusDot ────────────────────────────────────────────────────────────────

// const StatusDot = ({ color }: { color: string }) => (
//   <div style={{ width: 6, height: 6, borderRadius: "50%", background: color }} />
// );

// // ─── AddButton ────────────────────────────────────────────────────────────────

// const AddButton = ({ label }: { label: string }) => (
//   <button
//     style={{
//       width: "100%",
//       padding: 9,
//       border: "1.5px dashed #d1d5db",
//       borderRadius: 10,
//       background: "transparent",
//       fontSize: 12,
//       color: "#9ca3af",
//       cursor: "pointer",
//       fontFamily: "inherit",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       gap: 5,
//       marginBottom: 20,
//     }}
//   >
//     <PlusIcon /> {label}
//   </button>
// );

// // ─── Component ────────────────────────────────────────────────────────────────

// type T_Props = { open: boolean; onClose: () => void };

// const AccountsPanel: React.FC<T_Props> = ({ open, onClose }) => {
//   if (!open) return null;

//   return (
//     <>
//       {/* Backdrop */}
//       <div
//         onClick={onClose}
//         style={{
//           position: "fixed",
//           inset: 0,
//           background: "rgba(0,0,0,0.25)",
//           zIndex: 100,
//           backdropFilter: "blur(2px)",
//         }}
//       />

//       {/* Panel */}
//       <div
//         style={{
//           position: "fixed",
//           right: 0,
//           top: 0,
//           bottom: 0,
//           width: 340,
//           background: "#fff",
//           zIndex: 101,
//           boxShadow: "-8px 0 32px rgba(0,0,0,0.12)",
//           display: "flex",
//           flexDirection: "column",
//           animation: "slidePanel 0.22s ease",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             padding: "18px 20px",
//             borderBottom: "1px solid #f0f0f8",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             flexShrink: 0,
//           }}
//         >
//           <div>
//             <p style={{ fontSize: 15, fontWeight: 600, color: "#111827", letterSpacing: "-0.2px" }}>
//               Connected Accounts
//             </p>
//             <p style={{ fontSize: 11.5, color: "#9ca3af", marginTop: 2 }}>Manage your channels</p>
//           </div>
//           <div
//             onClick={onClose}
//             style={{
//               width: 30,
//               height: 30,
//               borderRadius: 7,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               cursor: "pointer",
//             }}
//           >
//             <CloseIcon />
//           </div>
//         </div>

//         {/* Agent card */}
//         <div
//           style={{
//             margin: "16px 18px 4px",
//             padding: "14px 16px",
//             background: "#f8f9fc",
//             border: "1px solid #e5e7eb",
//             borderRadius: 12,
//             display: "flex",
//             alignItems: "center",
//             gap: 12,
//           }}
//         >
//           <div
//             style={{
//               width: 44,
//               height: 44,
//               borderRadius: "50%",
//               background: "#4f46e5",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexShrink: 0,
//             }}
//           >
//             <span style={{ fontSize: 15, fontWeight: 600, color: "#fff" }}>JD</span>
//           </div>
//           <div>
//             <p style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>Jordan Davis</p>
//             <p style={{ fontSize: 11.5, color: "#6b7280", marginTop: 1 }}>Support Agent · Team Alpha</p>
//           </div>
//           <div style={{ marginLeft: "auto", display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 3 }}>
//             <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
//               <StatusDot color="#10b981" />
//               <span style={{ fontSize: 10.5, color: "#10b981", fontWeight: 500 }}>Online</span>
//             </div>
//           </div>
//         </div>

//         {/* Scrollable content */}
//         <div style={{ flex: 1, overflowY: "auto", padding: "16px 18px 20px" }}>
//           {/* Email section */}
//           <SectionLabel>Email Accounts</SectionLabel>

//           {/* Email 1 — connected */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 11,
//               padding: "12px 14px",
//               border: "1px solid #e5e7eb",
//               borderRadius: 10,
//               marginBottom: 7,
//               background: "#fff",
//             }}
//           >
//             <div
//               style={{
//                 width: 36,
//                 height: 36,
//                 borderRadius: 8,
//                 background: "#eef2ff",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 flexShrink: 0,
//               }}
//             >
//               <EmailAccountIcon />
//             </div>
//             <div style={{ flex: 1, minWidth: 0 }}>
//               <p
//                 style={{
//                   fontSize: 12.5,
//                   fontWeight: 500,
//                   color: "#111827",
//                   whiteSpace: "nowrap",
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                 }}
//               >
//                 support@techhelp.io
//               </p>
//               <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 2 }}>
//                 <StatusDot color="#10b981" />
//                 <span style={{ fontSize: 11, color: "#10b981", fontWeight: 500 }}>Connected</span>
//               </div>
//             </div>
//             <div
//               style={{
//                 width: 26,
//                 height: 26,
//                 borderRadius: 6,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 cursor: "pointer",
//               }}
//             >
//               <MoreDotsIcon />
//             </div>
//           </div>

//           {/* Email 2 — auth error */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 11,
//               padding: "12px 14px",
//               border: "1px solid #fca5a5",
//               borderRadius: 10,
//               marginBottom: 7,
//               background: "#fffbfb",
//             }}
//           >
//             <div
//               style={{
//                 width: 36,
//                 height: 36,
//                 borderRadius: 8,
//                 background: "#fee2e2",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 flexShrink: 0,
//               }}
//             >
//               <EmailAccountIcon error />
//             </div>
//             <div style={{ flex: 1, minWidth: 0 }}>
//               <p
//                 style={{
//                   fontSize: 12.5,
//                   fontWeight: 500,
//                   color: "#111827",
//                   whiteSpace: "nowrap",
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                 }}
//               >
//                 billing@techhelp.io
//               </p>
//               <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 2 }}>
//                 <StatusDot color="#ef4444" />
//                 <span style={{ fontSize: 11, color: "#dc2626", fontWeight: 500 }}>Auth required</span>
//               </div>
//             </div>
//             <button
//               style={{
//                 fontSize: 11,
//                 fontWeight: 600,
//                 color: "#dc2626",
//                 background: "#fee2e2",
//                 border: "none",
//                 borderRadius: 6,
//                 padding: "4px 9px",
//                 cursor: "pointer",
//                 fontFamily: "inherit",
//                 flexShrink: 0,
//               }}
//             >
//               Reconnect
//             </button>
//           </div>

//           <AddButton label="Add email account" />

//           {/* SMS section */}
//           <SectionLabel>SMS Numbers</SectionLabel>

//           {/* SMS — connected */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 11,
//               padding: "12px 14px",
//               border: "1px solid #e5e7eb",
//               borderRadius: 10,
//               marginBottom: 7,
//               background: "#fff",
//             }}
//           >
//             <div
//               style={{
//                 width: 36,
//                 height: 36,
//                 borderRadius: 8,
//                 background: "#ecfdf5",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 flexShrink: 0,
//               }}
//             >
//               <SmsAccountIcon />
//             </div>
//             <div style={{ flex: 1, minWidth: 0 }}>
//               <p style={{ fontSize: 12.5, fontWeight: 500, color: "#111827" }}>+1 (555) 234-5678</p>
//               <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 2 }}>
//                 <StatusDot color="#10b981" />
//                 <span style={{ fontSize: 11, color: "#10b981", fontWeight: 500 }}>Connected · Twilio</span>
//               </div>
//             </div>
//             <div
//               style={{
//                 width: 26,
//                 height: 26,
//                 borderRadius: 6,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 cursor: "pointer",
//               }}
//             >
//               <MoreDotsIcon />
//             </div>
//           </div>

//           <AddButton label="Add SMS number" />
//         </div>
//       </div>
//     </>
//   );
// };

// export default AccountsPanel;

import React from "react";
import { Drawer, Badge, Avatar, Space, Typography } from "antd";
import {
  CloseOutlined,
  MailOutlined,
  MessageOutlined,
  MoreOutlined,
  PlusOutlined,
  UserOutlined,
} from "@ant-design/icons";

// ─── Component ────────────────────────────────────────────────────────────────

type T_Props = { open: boolean; onClose: () => void };

const AccountsPanel: React.FC<T_Props> = ({ open, onClose }) => {
  return (
    <Drawer
      title={
        <div>
          <div className="text-[15px] font-semibold text-gray-900 tracking-[-0.2px]">Connected Accounts</div>
          <div className="text-[11.5px] text-gray-400 mt-0.5">Manage your channels</div>
        </div>
      }
      placement="right"
      onClose={onClose}
      open={open}
      width={500}
    >
      {/* Agent card */}
      {/* <div
        className="mx-[18px] mt-4 mb-1 p-[14px_16px] bg-[#f8f9fc] rounded-xl flex items-center gap-3"
        style={{ border: "1px solid #e5e7eb" }}
      >
        <Avatar size={44} className="bg-indigo-600 flex-shrink-0" icon={<UserOutlined />}>
          JD
        </Avatar>
        <div className="flex-1">
          <div className="text-[14px] font-semibold text-gray-900">Jordan Davis</div>
          <div className="text-[11.5px] text-gray-500 mt-0.5">Support Agent · Team Alpha</div>
        </div>
        <div className="flex flex-col items-end gap-0.5">
          <Space size={4}>
            <Badge status="success" />
            <span className="text-[10.5px] text-emerald-500 font-medium">Online</span>
          </Space>
        </div>
      </div> */}

      {/* Scrollable content */}
      <div className="flex-1 overflow-y-auto px-[18px] py-4 pb-5">
        {/* Email section */}
        <Typography.Paragraph className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.9px] mb-[9px] mt-2">
          Email Accounts
        </Typography.Paragraph>

        {/* Email 1 — connected */}
        <div
          className="flex items-center gap-[11px] p-[12px_14px] rounded-[10px] mb-1.5 bg-white"
          style={{ border: "1px solid #e5e7eb" }}
        >
          <div className="w-9 h-9 rounded-lg bg-indigo-50 flex items-center justify-center flex-shrink-0">
            <MailOutlined className="text-indigo-600" />
          </div>
          <div className="flex-1 min-w-0">
            <Typography.Paragraph style={{ margin: 0 }} className="text-[12.5px] font-medium text-gray-900 truncate">
              support@techhelp.io
            </Typography.Paragraph>
            <Space size={4} className="mt-0.5">
              <Badge status="success" />
              <span className="text-[11px] text-emerald-500 font-medium">Connected</span>
            </Space>
          </div>
          <div className="w-[26px] h-[26px] rounded-md flex items-center justify-center cursor-pointer">
            <MoreOutlined className="text-gray-400" />
          </div>
        </div>

        {/* Email 2 — auth error */}
        <div
          className="flex items-center gap-[11px] p-[12px_14px] rounded-[10px] mb-1.5 bg-[#fffbfb]"
          style={{ border: "1px solid #fca5a5" }}
        >
          <div className="w-9 h-9 rounded-lg bg-red-100 flex items-center justify-center flex-shrink-0">
            <MailOutlined className="text-red-600" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[12.5px] font-medium text-gray-900 truncate">billing@techhelp.io</div>
            <Space size={4} className="mt-0.5">
              <Badge status="error" />
              <span className="text-[11px] text-red-600 font-medium">Auth required</span>
            </Space>
          </div>
          <button className="text-[11px] font-semibold text-red-600 bg-red-100 border-0 rounded-md px-[9px] py-1 cursor-pointer font-inherit flex-shrink-0">
            Reconnect
          </button>
        </div>

        {/* Add email button */}
        <button
          className="w-full py-[9px] rounded-[10px] bg-transparent text-[12px] text-gray-400 cursor-pointer font-inherit flex items-center justify-center gap-1.5 mb-5"
          style={{ border: "1.5px dashed #d1d5db" }}
        >
          <PlusOutlined /> Add email account
        </button>

        {/* SMS section */}
        <div className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.9px] mb-[9px] mt-2">SMS Numbers</div>

        {/* SMS — connected */}
        <div
          className="flex items-center gap-[11px] p-[12px_14px] rounded-[10px] mb-1.5 bg-white"
          style={{ border: "1px solid #e5e7eb" }}
        >
          <div className="w-9 h-9 rounded-lg bg-emerald-50 flex items-center justify-center flex-shrink-0">
            <MessageOutlined className="text-emerald-600" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[12.5px] font-medium text-gray-900">+1 (555) 234-5678</div>
            <Space size={4} className="mt-0.5">
              <Badge status="success" />
              <span className="text-[11px] text-emerald-500 font-medium">Connected · Twilio</span>
            </Space>
          </div>
          <div className="w-[26px] h-[26px] rounded-md flex items-center justify-center cursor-pointer">
            <MoreOutlined className="text-gray-400" />
          </div>
        </div>

        {/* Add SMS button */}
        <button
          className="w-full py-[9px] rounded-[10px] bg-transparent text-[12px] text-gray-400 cursor-pointer font-inherit flex items-center justify-center gap-1.5"
          style={{ border: "1.5px dashed #d1d5db" }}
        >
          <PlusOutlined /> Add SMS number
        </button>
      </div>
    </Drawer>
  );
};

export default AccountsPanel;
